import React, { useCallback, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function detectApi(path) {
  const base = (typeof global !== 'undefined' && global.config && global.config.lyricDetectApiDomain)
    ? String(global.config.lyricDetectApiDomain).replace(/\/$/, '')
    : 'https://ai2.ikara.co/lyric-detect';
  return base + (path.startsWith('/') ? path : '/' + path);
}

export default function LyricHistoryPage() {
  const [items, setItems] = useState(null);
  const [error, setError] = useState('');
  const load = useCallback(async () => {
    try {
      const response = await fetch(detectApi('/api/handoff-timing/history'), { cache: 'no-store' });
      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Không đọc được lịch sử.');
      setItems(data.items || []);
      setError('');
    } catch (cause) {
      setError(cause.message || 'Không kết nối được dịch vụ detect.');
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  return <main style={{ maxWidth: 1180, margin: '0 auto', padding: '88px 20px 20px' }}>
    <h1>Lịch sử quét lyric</h1>
    <div style={{ display: 'flex', gap: 10, marginBottom: 20 }}><Link to="/admin/lyric-detect" style={{ display: 'inline-block', padding: '10px 16px', borderRadius: 8, background: '#245479', color: '#fff', fontWeight: 700, textDecoration: 'none' }}>← Quay lại Detect lyric</Link><button type="button" onClick={load} style={{ padding: '10px 16px', borderRadius: 8, border: '1px solid #d7cbb7', background: '#fff' }}>Làm mới</button></div>
    {error && <p role="alert">{error}</p>}
    {!items && !error && <p>Đang tải lịch sử…</p>}
    {items && items.length === 0 && <p>Chưa có lần quét nào.</p>}
    {items && items.map(job => <Link key={job.id}
      to={'/admin/lyric-detect?job=' + encodeURIComponent(job.id)}
      style={{ display: 'grid', gridTemplateColumns: 'minmax(180px,1fr) 160px 200px', gap: 12,
        padding: '12px 16px', borderBottom: '1px solid #eee5d6', color: '#2a251c' }}>
      <span><strong>{job.title}</strong><small style={{ display: 'block' }}>{job.preview}</small></span>
      <span>{job.state} · {job.stage}</span>
      <span>{new Date(job.createdAt).toLocaleString('vi-VN')}</span>
    </Link>)}
  </main>;
}
